var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 6.6138C6.95616 6.6138 6.11335 7.45661 6.11335 8.50047C6.11335 9.54433 6.95616 10.3871 8.00002 10.3871C9.04388 10.3871 9.88668 9.54433 9.88668 8.50047C9.88668 7.45661 9.04388 6.6138 8.00002 6.6138ZM5.11335 8.50047C5.11335 6.90433 6.40388 5.6138 8.00002 5.6138C9.59616 5.6138 10.8867 6.90433 10.8867 8.50047C10.8867 10.0966 9.59616 11.3871 8.00002 11.3871C6.40388 11.3871 5.11335 10.0966 5.11335 8.50047Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50501 6.49845C3.09896 3.99287 5.4347 2.48047 8.00002 2.48047C10.5654 2.48047 12.9013 3.993 14.4952 6.49877C14.8585 7.06833 15.0234 7.79791 15.0234 8.49714C15.0234 9.19636 14.8586 9.92594 14.4952 10.4955C12.9013 13.0013 10.5654 14.5138 8.00002 14.5138C5.43459 14.5138 3.09875 13.0013 1.50481 10.4955C1.14149 9.92594 0.976685 9.19636 0.976685 8.49714C0.976685 7.79777 1.14155 7.06805 1.50501 6.49845ZM8.00002 3.48047C5.85878 3.48047 3.80795 4.74127 2.34856 7.0355L2.34815 7.03615C2.11176 7.4065 1.97668 7.93663 1.97668 8.49714C1.97668 9.05764 2.11176 9.58777 2.34815 9.95812L2.34856 9.95877C3.80795 12.253 5.85878 13.5138 8.00002 13.5138C10.1413 13.5138 12.1921 12.253 13.6515 9.95877L13.6519 9.95812C13.8883 9.58777 14.0234 9.05764 14.0234 8.49714C14.0234 7.93663 13.8883 7.4065 13.6519 7.03615L13.6515 7.0355C12.1921 4.74127 10.1413 3.48047 8.00002 3.48047Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.51147667cab77ea70c78bcc5d7dc0c42.svg";
export { ForwardRef as ReactComponent };